import * as React from 'react';

// Types
import { IQuestionConfig } from '../../../manifests/types';

interface determineDisabledProps {
    disabled?: IQuestionConfig['disabled'];
    values: Record<string, any>;
    ancillaryData: Record<string, any>;
}

export const useDynamicDisabled = () => {
    const determineDisabled = ({ disabled, values, ancillaryData }: determineDisabledProps): boolean | undefined => {
        if (typeof disabled === 'function') {
            return disabled(ancillaryData, values);
        } else {
            return disabled;
        }
    };

    return { determineDisabled };
};

export default useDynamicDisabled;
